import React from 'react';
import { NavLink } from 'react-router-dom';

const navData = [
  { id: 0, path: 'transactions' },
  { id: 1, path: 'day' },
  { id: 2, path: 'monthly' },
  { id: 3, path: 'year' },
  { id: 4, path: 'compare' },
];

function Nav() {
  return (
    <nav className="mb-5">
      <ul className="flex gap-x-3">
        {navData.map(({ id, path: label }) => (
          <li key={id}>
            <NavLink
              className="px-5 text-[16px] py-2 tracking-wide text-gray-400 font-light capitalize"
              style={({ isActive }) => ({
                color: isActive ? '#00B4CC' : '',
                borderBottom: isActive ? '2px solid #00B4CC' : '',
              })}
              to={label.toLowerCase()}
            >
              {label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default Nav;
